// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"b4bc9ff5","938":"da76d4c0"}[chunkId] + ".chunk.js");